import c from './app-query-bar.vue';

export default c;
